/**
 * Form field height. Shared so the input and the dropdown trigger cannot drift apart again.
 *
 * This is the border-box height: at 52px with a 2px border the inner space is 48px. A Figma layer
 * reports 52 only when its stroke is set to Inside.
 */
export const FIELD_HEIGHT = 'h-[52px]';
